import {
  Component,
  computed,
  ElementRef,
  inject,
  OnDestroy,
  signal,
  ViewChild,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

import { UsersService } from 'src/app/services/users/users.service';
import packageJSON from '../../../../../package.json';
import { WorkflowEditorService } from '../workflow-editor/workflow-editor.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    MatTooltip,
    PayeeIconComponent,
    MatButton,
  ],
  host: {
    '[class.close]': 'close()',
  },
})
export class SidebarComponent implements OnDestroy {
  private authService = inject(AuthService);
  private usersService = inject(UsersService);
  private workflowEditorService = inject(WorkflowEditorService);

  private readonly destroy = new Subject<void>();

  readonly open = signal(true);
  @ViewChild('appVersion') el?: ElementRef;
  readonly close = computed(() => !this.open());

  get versionNumber() {
    return packageJSON.version;
  }

  get showHiddenPages(): boolean {
    return !!this.usersService.userSubject.value?.can_update_product_price;
  }

  constructor() {
    this.workflowEditorService.immersiveCanvas
      .pipe(takeUntil(this.destroy))
      .subscribe((immersive) => {
        this.open.set(!immersive);
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  toggleOpen() {
    this.open.update((value) => !value);
  }

  async logout(): Promise<void> {
    await this.authService.logout();
  }
}
